import React, { useState, useEffect } from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// CUSTOM HOOKS
import useGetAllMessagesTypes from "../../../customHooks/GET_requests/useGetAllMessagesTypes";
// COMPONENTS
import GlobalAlert2 from "../../home/GlobalAlert2";
// INTERFACES
import { SelectMessagesInterface } from "../../../interfaces/Components.interface";
import { MessageTypeInterface } from "../../../interfaces/MessageType.interface";
// CONSTANTS
import { BLANK_MESSAGE_TYPE } from "../../../constants/messagesTypes";

function SelectMessageType({ setFilteredValue }: SelectMessagesInterface) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Option } = Select;
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const [data, setData] = useState<MessageTypeInterface[]>([]);
	const [messageTypeSelected, setMessageTypeSelected] = useState<string>("ALL");

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */
	const { messagesTypes, isLoadingGetAllMessagesTypes, errorMessageGetAllMessagesTypes, isErrorGetAllMessagesTypes } =
		useGetAllMessagesTypes();

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChange = (newValue: string) => {
		const index = data.findIndex((item: any) => item.id === newValue);
		setMessageTypeSelected(newValue);
		setFilteredValue(data[index].name, data[index].id);
	};

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		if (messagesTypes) {
			setData([
				{
					...BLANK_MESSAGE_TYPE,
				},
				...messagesTypes,
			]);
		}
	}, [messagesTypes]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className=' generalStyles__width100'>
			<Select
				loading={isLoadingGetAllMessagesTypes}
				className='generalStyles__width250px'
				size='middle'
				value={messageTypeSelected}
				placeholder={t("general.messageType")}
				onChange={onChange}
				showSearch
				optionFilterProp='label' // Ensures Ant Design uses `label` for searching
				filterOption={(input, option) =>
					typeof option?.label === "string" && option.label.toLowerCase().includes(input.toLowerCase())
				}
			>
				{data.map((item: MessageTypeInterface) => (
					<Option key={item.id} value={item.id} label={item.name}>
						{item.name}
					</Option>
				))}
			</Select>
			<GlobalAlert2
				isError={isErrorGetAllMessagesTypes}
				isSuccess={false}
				requestType='GET'
				error={errorMessageGetAllMessagesTypes}
				name='Messages'
			/>
		</div>
	);
}

export default SelectMessageType;
